"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.renderIcon = exports.renderBelow = void 0;
var React = __importStar(require("react"));
var __1 = require("..");
var renderDescription = function (description, skeleton) { return (React.createElement(React.Fragment, null, description && (React.createElement("div", { className: "nimbus--interactive-list-item__description-wrapper" }, skeleton ? (React.createElement(__1.Text.Skeleton, { width: "large" })) : (React.createElement(__1.Text, { block: true, size: "small", appearance: "light" }, description)))))); };
var renderLabels = function (labels, skeleton) { return (React.createElement(React.Fragment, null, labels && (React.createElement(__1.Stack, { wrap: true, spacing: "tight" }, labels.map(function (label, index) { return (React.createElement(__1.Stack.Item, { key: "" + index }, skeleton ? (React.createElement(__1.Label.Skeleton, null)) : (React.createElement(__1.Label, { id: label.id, label: label.label, colorTag: label.colorTag, appearance: label.appearance })))); }))))); };
var renderBelow = function (description, labels, skeleton) {
    return (React.createElement(React.Fragment, null, (labels || description) && (React.createElement("div", { className: "nimbus--interactive-list-item__info" },
        description && renderDescription(description, skeleton),
        labels && renderLabels(labels, skeleton)))));
};
exports.renderBelow = renderBelow;
var renderIcon = function (icon, appearance) {
    return icon && React.createElement(__1.IconItem, { icon: icon, appearance: appearance });
};
exports.renderIcon = renderIcon;
//# sourceMappingURL=utils.js.map